var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductFilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x35_7_Water_Bottle"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m372.9 217.8v-16.4c0-29.5-9-57.8-26-81.9l-33.3-47v-41.9c0-16.9-13.8-30.6-30.6-30.6h-53.8c-16.9 0-30.6 13.8-30.6 30.6v41.7l-33.3 47.2c-17 24.1-26 52.3-26 81.8v16.5c0 10.3 4.9 19.4 12.4 25.3-7.7 8.3-12.5 19.3-12.5 31.5 0 14.2 6.5 26.9 16.6 35.4-10.2 8.5-16.6 21.2-16.6 35.4 0 12.2 4.7 23.3 12.5 31.5-7.5 5.9-12.4 15-12.4 25.3v56.5c0 29.4 23.9 53.3 53.3 53.3h127c29.4 0 53.3-23.9 53.3-53.3v-56.5c0-10.3-4.9-19.5-12.5-25.3 7.7-8.2 12.5-19.3 12.5-31.4 0-14.2-6.5-26.9-16.6-35.4 10.1-8.5 16.6-21.2 16.6-35.4 0-12.2-4.7-23.1-12.5-31.4 7.6-6 12.5-15.1 12.5-25.5zm-153.1-187.2c0-5.1 4.2-9.3 9.3-9.3h53.8c5.1 0 9.3 4.2 9.3 9.3v34.4h-72.4zm-34.6 290h141.5c13.7 0 24.7 11.1 24.7 24.7 0 13.7-11.1 24.7-24.7 24.7h-141.6c-13.7 0-24.7-11.1-24.7-24.7.1-13.6 11.1-24.7 24.8-24.7zm-24.7-46c0-13.7 11.1-24.7 24.7-24.7h141.5c13.7 0 24.7 11.1 24.7 24.7s-11.1 24.7-24.7 24.7h-141.5c-13.7 0-24.7-11.1-24.7-24.7zm191 184.1c0 17.7-14.3 32-32 32h-127c-17.7 0-32-14.3-32-32v-56.5c0-5.9 4.8-10.7 10.7-10.7h169.7c5.9 0 10.7 4.8 10.7 10.7v56.5zm0-240.9c0 5.9-4.8 10.7-10.7 10.7h-169.6c-5.9 0-10.7-4.8-10.7-10.7v-16.5c0-25.1 7.6-49.1 22.1-69.5l32.1-45.4h82.6l32.2 45.4c14.5 20.5 22.1 44.5 22.1 69.6z",
    fill: "#000000",
    "data-original": "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductFilling);
export default __webpack_public_path__ + "static/media/product-filling.cf94a247028bf7b238718bbe6aac2d32.svg";
export { ForwardRef as ReactComponent };